import { ListItem, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import styles from './DropdownMenuItem.module.css';

const cx = classNames.bind(styles);

interface MenuListItemProps {
  icon?: JSX.Element;
  text: string;
  url: string;
  selected?: boolean;
  test_id: string;
}

const MenuListItem = ({ icon, text, url, selected, test_id }: MenuListItemProps) => {
  return (
    <ListItem data-testid={test_id} button component={Link} to={url} className={cx(styles.root, { selected })}>
      <div className={styles.row}>
        {icon ? <div className={styles.icon}>{icon}</div> : null}
        <Typography className={styles.text}>{text}</Typography>
      </div>
    </ListItem>
  );
};

export default MenuListItem;
